<template>
  <div>
    <b-input-group class="searchForm">
      <b-form-input size="sm" v-model="search" placeholder="Search" @input="$emit('input', search)" />
      <b-input-group-append>
        <span @click="cleanInput" v-if="search"><i class="fa fa-times search-form-clean"/></span>
        <b-btn size="sm" variant="default" @click="onButtonClick">
          <WaveSpinner v-if="isBusy" color="white" inline />
          <span v-else>
            <i class="fa" :class="buttonIcon"/> {{ buttonText }}
          </span>
        </b-btn>
      </b-input-group-append>
    </b-input-group>

    <small tabindex="-1" class="form-text text-muted search-form-text" v-if="helpText">{{ helpText }}</small>
  </div>
</template>

<script>
  export default {
    props: {
      searchTextDefault: { type: String, default: '' },
      buttonText: { type: String, default: 'Search' },
      buttonIcon: { type: String, default: 'fa-search' },
      helpText: { type: String, required: false },
      isBusy: { type: Boolean, default: false },
      onButtonClick: { type: Function, required: false },
    },
    data() {
      return {
        search: this.searchTextDefault,
      }
    },
    methods: {
      cleanInput() {
        this.search = '';
        this.$emit('input', '');
      },
    },
  }
</script>

<style>
  .search-form-clean {
    position: absolute;
    right: 110px;
    top: 10px;
    z-index: 3;
    cursor: pointer;
    color: #ccc;
  }
  .search-form-text {
    font-size: 12px;
    margin-left: 15px;
  }
  .searchForm {
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/SearchForm.vue